import {
    FETCH_COMMISSION_CONFIGURATIONS_REQUEST,
    FETCH_COMMISSION_CONFIGURATIONS_SUCCESS,
    FETCH_COMMISSION_CONFIGURATIONS_FAILURE,
    CREATE_COMMISSION_CONFIGURATION_REQUEST,
    CREATE_COMMISSION_CONFIGURATION_SUCCESS,
    CREATE_COMMISSION_CONFIGURATION_FAILURE,
    UPDATE_COMMISSION_CONFIGURATION_REQUEST,
    UPDATE_COMMISSION_CONFIGURATION_SUCCESS,
    UPDATE_COMMISSION_CONFIGURATION_FAILURE,
    DELETE_COMMISSION_CONFIGURATION_REQUEST,
    DELETE_COMMISSION_CONFIGURATION_SUCCESS,
    DELETE_COMMISSION_CONFIGURATION_FAILURE,
} from "./types";

import {
    fetchCommissionConfigurations,
    createCommissionConfiguration,
    updateCommissionConfiguration,
    deleteCommissionConfiguration,
} from "../../services/agentCommissionService";

export const fetchCommissionConfigurationsRequest = () => ({
    type: FETCH_COMMISSION_CONFIGURATIONS_REQUEST,
});

export const fetchCommissionConfigurationsSuccess = (data) => ({
    type: FETCH_COMMISSION_CONFIGURATIONS_SUCCESS,
    payload: data,
});

export const fetchCommissionConfigurationsFailure = (error) => ({
    type: FETCH_COMMISSION_CONFIGURATIONS_FAILURE,
    payload: error,
});

export const fetchCommissionConfigurationsAction = () => async (dispatch) => {
    dispatch(fetchCommissionConfigurationsRequest());

    try {
        const response = await fetchCommissionConfigurations();

        if (response.success) {
            dispatch(
                fetchCommissionConfigurationsSuccess(response.data)
            );

            return {
                success: true,
                data: response.data,
            };
        }

        dispatch(
            fetchCommissionConfigurationsFailure(response.error)
        );

        return {
            success: false,
            error: response.error,
        };
    } catch (error) {
        const message =
            error.response?.data?.detail ||
            error.response?.data?.message ||
            error.message ||
            "Failed to retrieve agent commission configurations.";

        dispatch(
            fetchCommissionConfigurationsFailure(message)
        );

        return {
            success: false,
            error: message,
        };
    }
};

export const createCommissionConfigurationRequest = () => ({
    type: CREATE_COMMISSION_CONFIGURATION_REQUEST,
});

export const createCommissionConfigurationSuccess = (data) => ({
    type: CREATE_COMMISSION_CONFIGURATION_SUCCESS,
    payload: data,
});

export const createCommissionConfigurationFailure = (error) => ({
    type: CREATE_COMMISSION_CONFIGURATION_FAILURE,
    payload: error,
});

export const createCommissionConfigurationAction =
    (payload) => async (dispatch) => {
        dispatch(createCommissionConfigurationRequest());

        try {
            const response =
                await createCommissionConfiguration(payload);

            if (response.success) {
                dispatch(
                    createCommissionConfigurationSuccess(
                        response.data
                    )
                );

                return {
                    success: true,
                    data: response.data,
                    message: response.message,
                };
            }

            dispatch(
                createCommissionConfigurationFailure(
                    response.error
                )
            );

            return {
                success: false,
                error: response.error,
            };
        } catch (error) {
            const message =
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to create agent commission configuration.";

            dispatch(
                createCommissionConfigurationFailure(message)
            );

            return {
                success: false,
                error: message,
            };
        }
    };

export const updateCommissionConfigurationRequest = () => ({
    type: UPDATE_COMMISSION_CONFIGURATION_REQUEST,
});

export const updateCommissionConfigurationSuccess = (data) => ({
    type: UPDATE_COMMISSION_CONFIGURATION_SUCCESS,
    payload: data,
});

export const updateCommissionConfigurationFailure = (error) => ({
    type: UPDATE_COMMISSION_CONFIGURATION_FAILURE,
    payload: error,
});

export const updateCommissionConfigurationAction =
    (configurationId, payload) => async (dispatch) => {
        dispatch(updateCommissionConfigurationRequest());

        try {
            const response =
                await updateCommissionConfiguration(
                    configurationId,
                    payload
                );

            if (response.success) {
                dispatch(
                    updateCommissionConfigurationSuccess(
                        response.data
                    )
                );

                return {
                    success: true,
                    data: response.data,
                    message: response.message,
                };
            }

            dispatch(
                updateCommissionConfigurationFailure(
                    response.error
                )
            );

            return {
                success: false,
                error: response.error,
            };
        } catch (error) {
            const message =
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to update agent commission configuration.";

            dispatch(
                updateCommissionConfigurationFailure(message)
            );

            return {
                success: false,
                error: message,
            };
        }
    };

export const deleteCommissionConfigurationRequest = () => ({
    type: DELETE_COMMISSION_CONFIGURATION_REQUEST,
});

export const deleteCommissionConfigurationSuccess = (
    configurationId
) => ({
    type: DELETE_COMMISSION_CONFIGURATION_SUCCESS,
    payload: configurationId,
});

export const deleteCommissionConfigurationFailure = (error) => ({
    type: DELETE_COMMISSION_CONFIGURATION_FAILURE,
    payload: error,
});

export const deleteCommissionConfigurationAction =
    (configurationId) => async (dispatch) => {
        dispatch(deleteCommissionConfigurationRequest());

        try {
            const response =
                await deleteCommissionConfiguration(
                    configurationId
                );

            if (response.success) {
                dispatch(
                    deleteCommissionConfigurationSuccess(
                        configurationId
                    )
                );

                return {
                    success: true,
                    message: response.message,
                };
            }

            dispatch(
                deleteCommissionConfigurationFailure(
                    response.error
                )
            );

            return {
                success: false,
                error: response.error,
            };
        } catch (error) {
            const message =
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to delete agent commission configuration.";

            dispatch(
                deleteCommissionConfigurationFailure(message)
            );

            return {
                success: false,
                error: message,
            };
        }
    };